import { useEffect, useRef, useState } from "react";

export interface FileTypeChoice { id: string; name: string; description: string; icon: string; selected: boolean; count?: number }
interface Props {
  open: boolean;
  choices: FileTypeChoice[];
  onClose: () => void;
  onToggle: (id: string, visible: boolean) => void;
  onCreate?: (name: string) => void;
}

export function FileTypePickerDialog({ open, choices, onClose, onToggle, onCreate }: Props) {
  const dialog = useRef<HTMLDialogElement>(null);
  const [search, setSearch] = useState("");
  const [name, setName] = useState("");
  const [creating, setCreating] = useState(false);
  const searchInputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (open) {
      setSearch("");
      setName("");
      setCreating(false);
      dialog.current?.showModal();
      window.setTimeout(() => {
        searchInputRef.current?.focus();
      }, 50);
    } else {
      dialog.current?.close();
    }
  }, [open]);
  const duplicate = choices.some(choice => choice.name.trim().toLocaleLowerCase() === name.trim().toLocaleLowerCase());
  const matches = choices.filter(choice => `${choice.name} ${choice.description}`.toLocaleLowerCase().includes(search.trim().toLocaleLowerCase()));
  return <dialog ref={dialog} className="receipt-dialog file-type-picker" aria-labelledby="file-type-picker-title" onCancel={event => { event.preventDefault(); onClose(); }} onClick={event => { if (event.target === event.currentTarget) onClose(); }}>
    <header><div><small>PROJECT FILES</small><h2 id="file-type-picker-title">ประเภทไฟล์</h2></div><button type="button" onClick={onClose} aria-label="ปิดประเภทไฟล์">×</button></header>
    <div className="receipt-dialog__body">
      <p className="file-type-picker__hint">เลือกประเภทที่แสดงในเมนู ประเภทที่ซ่อนยังค้นหาและเรียกใช้ได้ตามสิทธิ์เดิม</p>
      <div className="file-type-picker__toolbar"><input ref={searchInputRef} aria-label="ค้นหาประเภทไฟล์" placeholder="ค้นหาประเภทไฟล์…" value={search} onChange={event => setSearch(event.target.value)} />{onCreate && <button type="button" onClick={() => setCreating(!creating)} aria-expanded={creating}>＋ สร้างประเภทใหม่</button>}</div>
      {creating && onCreate && <form className="file-type-picker__create" onSubmit={event => { event.preventDefault(); if (!name.trim() || duplicate) return; onCreate(name.trim()); setCreating(false); setName(""); }}>
        <label>ชื่อประเภทใหม่<input value={name} maxLength={100} onChange={event => setName(event.target.value)} placeholder="เช่น ยานรบ หรือวิชาลมปราณ" /></label>
        {duplicate && <p role="alert">มีประเภทนี้แล้ว เลือกจากรายการเพื่อใช้ประเภทเดิมได้เลย</p>}
        <button type="submit" className="primary" disabled={!name.trim() || duplicate}>สร้างและแสดงในเมนู</button>
      </form>}
      <div className="file-type-picker__list">{matches.map(choice => <label key={choice.id} className="file-type-picker__choice">
        <span className="file-type-picker__icon" aria-hidden="true">{choice.icon || "◇"}</span><span><strong>{choice.name}</strong><small>{choice.description?.endsWith("structured world data") ? "" : choice.description}</small></span>
        {choice.count !== undefined && <small>{choice.count} ไฟล์</small>}<input type="checkbox" aria-label={`แสดง ${choice.name} ในเมนู`} checked={choice.selected} onChange={event => onToggle(choice.id, event.target.checked)} />
      </label>)}</div>
      {!matches.length && <p>ไม่พบประเภทไฟล์ที่ตรงกับคำค้น</p>}
    </div><footer><small>แสดง {choices.filter(choice => choice.selected).length} จาก {choices.length} ประเภท</small><button type="button" onClick={onClose}>เสร็จสิ้น</button></footer>
  </dialog>;
}
